/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "../models";
import * as Mappers from "../models/activityFormMappers";
import * as Parameters from "../models/parameters";
import { ProfiBazaAPIContext } from "../profiBazaAPIContext";

/** Class representing a ActivityForm. */
export class ActivityForm {
  private readonly client: ProfiBazaAPIContext;

  /**
   * Create a ActivityForm.
   * @param {ProfiBazaAPIContext} client Reference to the service client.
   */
  constructor(client: ProfiBazaAPIContext) {
    this.client = client;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  saveOrbeonActivityForm(options?: Models.ActivityFormSaveOrbeonActivityFormOptionalParams): Promise<msRest.RestResponse>;
  /**
   * @param callback The callback
   */
  saveOrbeonActivityForm(callback: msRest.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  saveOrbeonActivityForm(options: Models.ActivityFormSaveOrbeonActivityFormOptionalParams, callback: msRest.ServiceCallback<void>): void;
  saveOrbeonActivityForm(options?: Models.ActivityFormSaveOrbeonActivityFormOptionalParams | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<msRest.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      saveOrbeonActivityFormOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new msRest.Serializer(Mappers);
const saveOrbeonActivityFormOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "rizp/ActivityForm",
  queryParameters: [
    Parameters.activityId,
    Parameters.formPartId,
    Parameters.document
  ],
  responses: {
    200: {},
    default: {}
  },
  serializer
};
